import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaHeadset } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ZohoSalesIQ from "./ZohoSalesIQ";
import "./LiveChatPage.css";

const LiveChatPage = () => {
  const navigate = useNavigate();

  const [chatReady, setChatReady] = useState(false);
  const [chatError, setChatError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    let intervalId;
    let timeoutId;

    const isZohoReady = () => {
      const salesiq = window.$zoho?.salesiq;

      return Boolean(
        salesiq?.floatwindow?.open ||
        salesiq?.chat?.start ||
        document.getElementById("zsiq_float")
      );
    };

    const checkReady = () => {
      if (cancelled) return;

      if (isZohoReady()) {
        setChatReady(true);
        setLoading(false);
        setChatError("");

        if (intervalId) clearInterval(intervalId);
        if (timeoutId) clearTimeout(timeoutId);
      }
    };

    checkReady();

    intervalId = setInterval(checkReady, 500);

    timeoutId = setTimeout(() => {
      if (cancelled) return;

      checkReady();

      if (!isZohoReady()) {
        setLoading(false);
        setChatError(
          "Zoho chat haijapakia. Hakikisha mtandao upo na SalesIQ widget imewashwa."
        );
      }
    }, 15000);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, []);

  
const handleStartChat = () => {
  setChatError("");

  const salesiq = window.$zoho?.salesiq;

  try {
    // Jaribu API ya kufungua messenger ikiwa inapatikana.
    if (typeof salesiq?.floatwindow?.visible === "function") {
      salesiq.floatwindow.visible("show");
      return;
    }

    if (typeof salesiq?.floatwindow?.open === "function") {
      salesiq.floatwindow.open();
      return;
    }

    // Jaribu kubonyeza launcher ya widget.
    const launcher = document.querySelector(
      "#zsiq_float, .zsiq_float, [id^='zsiq_float']"
    );

    if (launcher instanceof HTMLElement) {
      launcher.click();
      return;
    }

    setChatError(
      "Zoho chat bado haijawa tayari. Subiri kidogo kisha ujaribu tena."
    );
  } catch (error) {
    console.error("Zoho SalesIQ error:", error);

    setChatError(
      "Imeshindikana kufungua chat. Tafadhali jaribu tena."
    );
  }
};

  return (
    <div className="customer-care-page">
      {/* Zoho SalesIQ widget */}
      <ZohoSalesIQ />

      <header className="customer-care-header">
        <button
          type="button"
          className="back-button"
          onClick={() => navigate(-1)}
        >
          <FaArrowLeft />
          <span>Back</span>
        </button>

        <div className="customer-care-brand">
          <div className="brand-icon">
            <FaHeadset />
          </div>

          <div className="brand-text">
            <span>BFC Trade</span>
            <strong>Customer Care</strong>
          </div>
        </div>

        <div className="online-status">
          <span className="online-dot" />
          <span>Support</span>
        </div>
      </header>

      <main className="customer-care-main">
        <section className="customer-care-card">
          <div className="large-headset">
            <FaHeadset />
          </div>

          <h1>BFC Trade Customer Care</h1>

          <p>
            Welcome to BFCTrade Support! Karibu BFCTrade Support!
            We can help with your account, deposits, withdrawals,
            and other issues. Tunaweza kukusaidia kuhusu akaunti
            yako, kuweka pesa, kutoa pesa na matatizo mengine.
            Please never share your password or payment PIN.
            Tafadhali usitume password au PIN yako ya malipo.
          </p>

          <button
            type="button"
            className="start-chat-button"
            onClick={handleStartChat}
            disabled={loading && !chatReady}
          >
            <FaHeadset />

            <span>
              {loading && !chatReady
                ? "Loading Customer Care..."
                : "Chat with Customer Care"}
            </span>
          </button>

          {loading && (
            <p role="status">
              Tunaandaa mazungumzo yako...
            </p>
          )}

          {chatError && (
            <div className="chat-error" role="alert">
              <p>{chatError}</p>

              <button
                type="button"
                onClick={() => window.location.reload()}
              >
                Try Again
              </button>
            </div>
          )}

          <div className="support-info">
            <div className="support-item">
              <strong>Support</strong>
              <span>Online chat</span>
            </div>

            <div className="support-item">
              <strong>Response time</strong>
              <span>Depends on agent availability</span>
            </div>

            <div className="support-item">
              <strong>Website</strong>
              <span>bfctrade.cc</span>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default LiveChatPage;